import React from 'react';
import PropTypes from 'prop-types';

import { Notification } from 'ui-connect';
import Translate from 'components/Translate';
import { trailsHash } from 'services/omt/subscription/subscriptionFields';
import styles from './NewSendToDevice.module.css';

class SyncNotification extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            messageKey,
            itemName,
            autoClose,
            isShow,
            onClose,
            onLearnMoreHelpItemClicked,
            zIndex,
            isFromTrails
        } = this.props;

        return (
            messageKey !== null && (
                <Notification open={isShow} onClose={onClose} autoClose={autoClose} zIndex={zIndex}>
                    <div className={styles.css_table}>
                        <div className={styles.css_tr}>
                            <div className={styles.css_td_notificationNote}>
                                {isFromTrails ? (
                                    <Translate ns={trailsHash} content={'trail_send_to_device_message'} />
                                ) : (
                                    <Translate ns="device" content={messageKey} params={{ 0: itemName }} />
                                )}
                            </div>
                            <div className={styles.css_td_notificationLink} onClick={onLearnMoreHelpItemClicked}>
                                <Translate
                                    className={styles.notificationLearnMore}
                                    ns="device"
                                    content={'send_to_device_learn_more'}
                                    tag={'div'}
                                />
                            </div>
                        </div>
                    </div>
                </Notification>
            )
        );
    }
}

SyncNotification.propTypes = {
    messageKey: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    autoClose: PropTypes.bool,
    renderTimeoutVal: PropTypes.number
};

SyncNotification.defaultProps = {
    onClose: () => {},
    autoClose: true,
    renderTimeoutVal: 1000,
    nameSpace: 'activity'
};

export default SyncNotification;
